<template>
  <v-navigation-drawer
    :value="menuOpen"
    @input="(newValue) => $store.commit('MainTemplate/setMenuOpen', newValue)"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title id="menu.logo" class="d-flex justify-center">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo-ePublic.png" class="mb-5" />
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle id="menu.ano_selector" class="d-flex justify-center">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir &&
            item.children.filter((child) => child.exibir !== false && $can(child.permissions))
              .length > 0
        )"
        :key="item.title"
        :id="item.id"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <!-- <v-list-item
                :to="item.to || undefined"
                link
              > -->
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
          <!-- </v-list-item
              > -->
        </template>
        <v-list-item
          v-for="child in item.children"
          v-show="child.exibir !== false && $can(child.permissions)"
          :key="child.title"
          :id="child.id"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    menu() {
      return {
        items: [
          {
            id: "menu.inicio",
            icon: "mdi mdi-home",
            title: "Início",
            exibir: true,
            children: [
              {
                id: "menu.ir_para_inicio",
                title: "Ir para Início",
                to:
                  (this.user ? this.user.roleName : "") === "professor"
                    ? {
                        name: "acessoProfessor.home",
                      }
                    : {
                        name:
                          (this.user ? this.user.roleName : "") === "prof-auxiliar"
                            ? "acessoProfessor.home"
                            : "home",
                      },
                icon: "",
              },
              {
                id: "menu.ir_para_notifiq",
                title: "Ir para notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.agenda",
            icon: "mdi mdi-book",
            title: "Agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                id: "menu.ir_para_agendas",
                title: "Ir para Agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            id: "menu.avisos",
            icon: "mdi mdi-alert",
            title: "Avisos",
            exibir: true,
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                id: "menu.ir_para_avisos",
                title: "Ir para Avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.matriculas",
            icon: "mdi mdi-account-school",
            title: "Matrículas",
            exibir: true,
            children: [
              {
                id: "menu.ver_matriculas",
                title: "Ver Matrículas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              {
                id: "menu.ver_alunos",
                title: "Ver Alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                id: "menu.pesquisa_avancada",
                title: "Pesquisa avançada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.turmas",
            icon: "mdi mdi-school",
            title: "Turmas",
            exibir: true,
            children: [
              {
                id: "menu.ver_turmas",
                title: "Ver turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                id: "menu.gestao_anos",
                title: "Gestão de anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                id: "menu.gestao_disciplinas",
                title: "Gestão de disciplinas",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            id: "menu.planos",
            icon: "mdi mdi-note-text",
            title: "Listar Planos",
            exibir:
              (this.user ? this.user.roleName : "") !== "professor" &&
              (this.user ? this.user.roleName : "") !== "prof-auxiliar",
            children: [
              {
                id: "menu.listar_planos_anuais",
                title: "Planos Anuais",
                to: { name: "gestoesDeAulas.planosAnuais" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.listar_planos",
                title: "Planos Bimestrais",
                to: { name: "gestoesDeAulas.planos" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.listar_planos_infantis",
                title: "Planos Infantis Bimestrais",
                to: { name: "gestoesDeAulas.planosInfantil" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              // {
              //   title: "Planos infantis anuais",
              //   to: { name: "gestoesDeAulas.planosAnuaisInfantil" },
              //   icon: "",
              //   permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              // },
            ],
          },
          {
            id: "menu.diario_online",
            icon: "mdi mdi-human-male-board-poll",
            title: "Diário online",
            exibir: true,
            children: [
              {
                id: "menu.diario_online.listar_todos",
                title: "Listar todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.diario_online.gestao_geral",
                title: "Gestão geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
              },
              {
                id: "menu.diario_online.agendas",
                title: "Agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
              },
            ],
          },
          // aqui
          {
            id: "menu.diario_auxiliares",
            icon: "mdi mdi-human-male-board",
            title: "Diário de Auxiliares",
            exibir: true,
            children: [
              {
                id: "menu.diario_auxiliares.listar_todos",
                title: "Listar todos",
                to: { name: "gestoesDeAulasAuxiliares" },
                icon: "",
                permissions: [
                  "gestoesDeAulasAuxiliares.*",
                  "gestoesDeAulasAuxiliares.criar",
                  "gestoesDeAulasAuxiliares.listar",
                  "atendimentosAuxiliares.listar",
                ],
              },
            ],
          },
          {
            id: "menu.diario_aee",
            icon: "mdi mdi-human-male-board-poll",
            title: "Diário AEE",
            exibir: true,
            children: [
              {
                id: "menu.diario_aee.listar_todos",
                title: "Listar todos",
                to: { name: "educacaoInclusiva" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.diario_aee.planos_aee",
                title: "Planos AEE",
                to: { name: "educacaoInclusiva.planosAEE" },
                icon: "",
                permissions: ["educacaoInclusiva.*", "educacaoInclusiva.syncAll"],
              },
            ],
          },
          {
            id: "menu.relatorios",
            icon: "mdi mdi-file",
            title: "Relatórios",
            exibir: true,
            children: [
              {
                id: "menu.ver_todos_relatorios",
                title: "Ver todos",
                to: { name: `relatorios`, params: { franquiaId: this.user?.franquia.id } },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            id: "menu.usuarios",
            icon: "mdi mdi-account-switch",
            title: "Usuários",
            exibir: true,
            children: [
              {
                id: "menu.ver_professores",
                title: "Ver Professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                id: "menu.bloqueios_liberacoes",
                title: "Bloqueios/Liberações",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
              {
                id: "menu.outros_usuarios",
                title: "Outros",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            id: "menu.financeiro",
            icon: "fa fa-money",
            title: "Financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                id: "menu.mensalidades",
                title: "Mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                id: "menu.gestao_caixas",
                title: "Gestão de Caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            id: "menu.administracao",
            icon: "mdi mdi-account-network",
            title: "Administração",
            exibir: true,
            children: [
              {
                id: "menu.administracao.sala_de_situacao",
                title: "Sala de Situação",
                to: { name: "salaDeSituacao" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                id: "menu.administracao.escolas",
                title: "Escolas",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                id: "menu.bolsa_familia",
                title: "Bolsa Família",
                to: { name: "bolsa-familia" },
                permissions: ["bolsaFamilia.*"],
                icon: "",
              },
              {
                id: "menu.calculadora_fundeb",
                title: "Calculadora FUNDEB",
                to: { name: "fundeb.calculadora" },
                permissions: ["franquias.*"],
                exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
              {
                id: "menu.administracao.meus_horarios",
                title: "Meus Horários",
                to: {
                  name: "instrutores.meusHorarios",
                },
                exibir: !!this.user?.professor?.id,
                icon: "",
              },
              {
                id: "menu.administracao.horarios_professores",
                title: "Horários dos Professores",
                to: { name: "instrutores.horarios" },
                icon: "mdi-clock-outline",
                permissions: ["users.*"],
              },
            ],
          },
          {
            icon: "mdi-account-search",
            title: "Busca Ativa",
            id: "menu.busca_ativa",
            exibir: true,
            children: [
              {
                id: "menu.busca_ativa.visao_geral",
                title: "Visão Geral",
                to: { name: "buscaAtiva.visaoGeral" },
                permissions: ["buscaAtiva.visualizar", "buscaAtiva.*"],
                icon: "",
              },
              {
                id: "menu.busca_ativa.turmas_com_incidencia",
                title: "Turmas com Incidência",
                to: { name: "buscaAtiva.turmasComIncidencia" },
                permissions: ["buscaAtiva.visualizar", "buscaAtiva.*"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.pontofiq",
            icon: "mdi mdi-clock-check-outline",
            title: "PontoFiq",
            exibir: true,
            children: [
              {
                id: "menu.pontofiq.meus_pontos",
                title: "Meus Pontos",
                to: { name: "colaboradores.meusPontos" },
                permissions: ["colaboradores.meusPontos"],
                icon: "",
              },
              {
                id: "menu.pontofiq.ponto_colaboradores",
                title: "Ponto dos Colaboradores",
                to: { name: "colaboradores.pontos" },
                permissions: ["colaboradores.pontos"],
                icon: "",
              },
              {
                id: "menu.pontofiq.minhas_faltas",
                title: "Minhas Faltas Justificadas",
                to: { name: "colaboradores.faltasJustificadas" },
                permissions: ["colaboradores.faltasJustificadas.solicitar"],
                icon: "",
              },
              {
                id: "menu.pontofiq.gerenciar_faltas",
                title: "Gerenciar Faltas",
                to: { name: "colaboradores.faltasJustificadas.gerenciar" },
                permissions: ["colaboradores.faltasJustificadas.gerenciar"],
                icon: "",
              },
              {
                id: "menu.pontofiq.justificativas_massa",
                title: "Justificativas em Massa",
                to: { name: "colaboradores.justificativaMassa" },
                permissions: ["colaboradores.justificativaMassa"],
                icon: "",
              },
              {
                id: "menu.pontofiq.feriados",
                title: "Gestão de Feriados",
                to: { name: "feriados.gerenciar" },
                permissions: ["feriados.gerenciar"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.notifiq",
            icon: "mdi-bell-ring",
            title: "Notifiq",
            exibir: true,
            children: [
              {
                id: "menu.notifiq.presenca",
                title: "Presença no Notifiq",
                to: { name: "notifiq.indexNotifiq" },
                permissions: ["notifiq.listaPresencasNotifiq"],
                icon: "",
              },
            ],
          },
          {
            icon: "query_stats",
            title: "Desempenho Pedagógico",
            exibir: true,
            children: [
              {
                title: "Desempenho Professor",
                to: { name: "usabilidade.usabilidadeDoSistemaProfessor" },
                icon: "",
                permissions: ["desempenhoPedagogico.desempenhoProfessor"],
              },
              // {
              //   title: "Desempenho Coordenador",
              //   to: { name: "usabilidade.usabilidadeDoSistemaCoordenador" },
              //   icon: "",
              //   permissions: ["desempenhoPedagogico.desempenhoCoordenador"],
              // },
              // {
              //   title: "Pendências",
              //   to: { name: "gestoesDeAulas.pendencias" },
              //   icon: "",
              //   permissions: ["gestoesDeAulas.pendencias"],
              // },
            ],
          },
          {
            id: "menu.ajuda_tutorial",
            icon: "mdi mdi-help",
            title: "Ajuda e tutorial",
            exibir: true,
            children: [
              {
                id: "menu.tutoriais",
                title: "Tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
              // {
              //   title: "Fale conosco",
              //   href: "https://tawk.to/caju",
              //   target: "_blank",
              // },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  async mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
    await this.carregarTiposAcesso();
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
      tiposAcesso: {
        pode_diario_online: true,
        pode_diario_auxiliar: true,
      },
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
    async carregarTiposAcesso() {
      const roleName = this.user?.roleName || "";
      if (["professor", "prof-auxiliar"].includes(roleName)) {
        try {
          const response = await this.$services.authService.getTiposAcessoProfessor();
          this.tiposAcesso = response;
        } catch (error) {
          console.error("Erro ao carregar tipos de acesso:", error);
        }
      }
    },
    deveExibirDiarioOnline() {
      const roleName = this.user?.roleName || "";
      if (!["professor", "prof-auxiliar"].includes(roleName)) {
        return true;
      }
      if (roleName === "professor") {
        return true;
      }
      return this.tiposAcesso.pode_diario_online;
    },
    deveExibirDiarioAuxiliar() {
      const roleName = this.user?.roleName || "";
      if (!["professor", "prof-auxiliar"].includes(roleName)) {
        return true;
      }
      if (roleName === "prof-auxiliar") {
        return true;
      }
      return this.tiposAcesso.pode_diario_auxiliar;
    },
  },
};
</script>
